<div id="statusElement">
    <app-status-card
    [title]="statusCardData.title"
    [statusText]="statusCardData.statusText"
    [statusClass]="statusCardData.statusClass"
    [infoBoxMessage]="statusCardData.infoBoxMessage"
    [details]="statusCardData.details"
    [infoText]="statusCardData.infoText"
    [requestTitle]="statusCardData.requestTitle"
    [requestDescription]="statusCardData.requestDescription"
    [requestLink]="statusCardData.requestLink"
    [requestLinkText]="statusCardData.requestLinkText"
    [infoImportant]="statusCardData.infoImportant"
    [requestDescriptionInfoImportant]="statusCardData.requestDescriptionInfoImportant"
    [requestTitleImportant]="statusCardData.requestTitleImportant"
    [infoImportantStrong]="statusCardData.infoImportantStrong"
  ></app-status-card>
</div>


<div id="faqElement" >
    <app-faq-card [faqs]="faqCardData" [titleFaq]="titleFaq" ></app-faq-card>
</div>

